
/**
 * pubkeys.js - stores all pubkeys used across the program
 */

import {PublicKey} from '@solana/web3.js';

/// program ids

export const TOKEN_PROGRAM_ID: PublicKey = new PublicKey(
  'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA', // localnet && devnet && mainnet
);
export const ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID: PublicKey = new PublicKey(
  'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL', // localnet && devnet && mainnet
);
// export const TOKEN_SALE_PROGRAM_ID: PublicKey = new PublicKey(
//   'HsJf4gVLa9QgGeYRXr5YSMfBRXUSgnASXJD4n61e2ug9', // localnet && devnet && mainnet
// );
export const TOKEN_SALE_PROGRAM_ID: PublicKey = new PublicKey(
  'FGsPzi6df2SL1ycYaiXB5bP8WguC9iWVhdoChn3TVjLN', // localnet && devnet && mainnet
);
export const TOKEN_WHITELIST_PROGRAM_ID: PublicKey = new PublicKey(
  '4ikowHMssMavQeDUaDVGPwsBcNMnU1nkzAJikMFG5mfv', // localnet && devnet && mainnet
);

/// mint & account pubkeys

// these are updated with pubkeys generated from spl-token
export const mintUSDTPubkey = new PublicKey('HujVQcs2X7EcLZvx1GBaFpEp4pa6NPyR9PLkUHApU4Lm'); // change this to USDT mint
export const mintSOLRPubkey = new PublicKey('HJ9kSgWDhoiiA873SL7h5r1Nj5bTmLxLTVaRokELp3Cs'); // change this to SOLR mint
export const poolAccountUSDT = new PublicKey('JCD8jNpLnZpqWzjTnWG1M7zQ8YXb2LFdLX4BZCjgbB3F'); // change this to pool USDT account
export const saleAccountSOLR = new PublicKey('9vV3j1YgaLeXCx4gdTmSkwTEJ81anPU3Zsq9ATZxBnuy'); // change this to token-sale SOLR account

// this is updated with pubkey generated after init token sale
export const tokenSaleStateAccount = new PublicKey('9TR1pCHbnhEJN5r17S18gfP2FoGZzsqjvwvhJ6MvnZPD'); // change this to token-sale state account

// this is updated with pubkey generated after init token whitelist
export const tokenWhitelistMap = new PublicKey('4dkW3qpDuu26eHPhouyHQhRBF5jSjZXYi69DbUWjUhmt'); // change this to token-whitelist map account